<template>
  <div class="container-fluid p-0">
    <b-card class="info-text" style="border-radius: 16px">
      <div id="siteInfo">
        <b-row>
          <b-col class="mb-4">
            <div>
              <p v-if="this.$route.name !== 'form-create'" class="info-head-text">Survey Name</p>
              <p v-else class="info-head-text">Form</p>
            </div>
            <div>
              {{ info.eventName }}
            </div>
          </b-col>

          <b-col
            v-if="$route.path.includes('create') || $route.path.includes('submitted')"
            class="mb-4"
          >
            <div>
              <p class="info-head-text">{{ label }}</p>
            </div>
            <div>
              {{ status }}
            </div>
          </b-col>
        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import moment from 'moment';

  export default {
    name: 'PersonInfo',
    props: ['info', 'scopeData', 'survey'],
    computed: {
      ...mapGetters(['dirtyPersonSurvey']),
      label() {
        if (this.$route.path.includes('submitted')) {
          return 'Reporting Date';
        } else {
          return 'Survey Status';
        }
      },
      status() {
        if (this.survey.surveyStatus === 'New') {
          return 'New Survey';
        } else if (this.survey.surveyStatus === 'Draft') {
          return (
            'Editing Draft Survey Created: ' + this.formatDate(this.survey.surveyCompletedDate)
          );
        } else if (
          this.survey.surveyStatus === 'Submitted' &&
          !this.$route.path.includes('submitted')
        ) {
          return (
            'New Survey Entry Based On Answers Submitted: ' +
            this.formatDate(this.survey.surveyCompletedDate)
          );
        } else if (
          this.survey.surveyStatus === 'Submitted' &&
          this.$route.path.includes('submitted')
        ) {
          return `Submitted on: ${this.formatDate(this.survey.surveyCompletedDate)}`;
        }
      },
    },
    methods: {
      formatDate(date) {
        if (date == null || date === '') {
          return '';
        } else {
          return moment(date).format('MMM DD YYYY HH:mm');
        }
      },
    },
  };
</script>
